<template>
    <Main
      :Slides="Slides"
      :Questions="Questions"
      :themeMode="true"
      :mainColor="'#444'"
      :secondColor="secondColor"
      :darkTheme="darkMode"
      :backgroundURL="'https://i1.wp.com/gabius-onkologie.de/wp-content/uploads/2017/02/grey-white-background.jpg'"
    ></Main>
</template>

<script>
import Main from './components/Main.vue';

export default {
  name: 'App',
  components: {
    Main
  },
  data: () => ({
    Questions: [{text: "Welche Immobilie möchten Sie verkaufen?", slide: 0},
                {text: "Um welche Gebäudeart handelt es sich?", slide: 1}],
    Slides: [
      [{text: "Grundstück", img: "https://jk-design.cc/testing/images/grundstueck.svg", id: "immo_1"},
      {text: "Haus", img: "https://jk-design.cc/testing/images/haus.svg", id: "immo_2"},
      {text: "Wohnung", img: "https://jk-design.cc/testing/images/wohnung.svg", id: "immo_3"},
      {text: "Gewerbe", img: "https://jk-design.cc/testing/images/gewerbe_3.svg", id: "immo_4"}],

      [{text: "Haus", img: "https://jk-design.cc/testing/images/haus.svg", id: "art_1"},
      {text: "Wohnung", img: "https://jk-design.cc/testing/images/wohnung.svg", id: "art_2"},
      {text: "Grundstück", img: "https://jk-design.cc/testing/images/grundstueck.svg", id: "art_3"}]
    ],
    backgroundURL: 'https://d1pk245wpfxuep.cloudfront.net/uploads/attachment/image/65603/bg-ck.jpg',
    darkMode: false,
    secondColor: '#2980B9'
  }),
  methods: {
    
  },
  created() {
    Event.$on('Toggle Darkmode', () => this.darkMode = !this.darkMode);
  }
};
</script>

<style>

</style>
